<template>
  <div class="localization section">
    <h2 v-if="title">{{ $t('localization.localizacion') }} </h2>
    <div v-if="title"
         class="separator" />
    <div class="container-localization">
      <div v-if="title"
           class="container-localization-card">
        <artist-venue-card :element="venue"
                           :type="'venue'"
                           size="big" />
      </div>
      <div class="container-localization-info">
        <ul class="localization-info">
          <li v-if="venue.address || venue.latitude || venue.longitude"
              class="address location-item">
            <p class="location-title">{{ $t('localization.direccion') }}</p>
            <p>{{ venue.address }}</p>
            <google-maps-modal :location="{latitude: venue.latitude, longitude: venue.longitude}" />
          </li>
          <li v-if="venue.directions"
              class="how-to-get location-item">
            <p class="location-title">{{ $t('localization.comoLlegar') }} </p>
            <p>{{ venue.directions }}</p>
          </li>
        </ul>
        <ul class="localization-info">
          <li v-if="accommodation && accommodation.service === 'airbnb'"
              class="accommodation location-item">
            <p class="location-title">{{ $t('localization.alojamiento') }}</p>
            <b-button class="transparent small location-button location-button-airbnb"
                      @click="openAirbnb">
              <span class="logo-airbnb" />
              <span>{{ $t('localization.buscarConAirbnb') }}</span>
            </b-button>
          </li>
          <li v-if="accommodation && accommodation.service === 'stay'"
              class="accommodation location-item">
            <p class="location-title">{{ $t('localization.alojamiento') }}</p>
            <b-button class="transparent small location-button location-button-stay"
                      @click="openStay">
              <span>{{ $t('airbnb.BuscarAlojamiento') }}</span>
            </b-button>
          </li>
          <li v-if="transport && transport.url"
              class="transport location-item">
            <p class="location-title">{{ $t('localization.transporte') }}</p>
            <b-button target="_blank"
                      class="transparent small location-button"
                      :href="transport.url">
              <span>{{ transport.description }}</span>
            </b-button>
          </li>
          <!-- <li class="parking location-item">
            <p class="location-title">{{ $t('localization.parking') }}</p>
            <p>Si vas en coche, encuentra el marking más cercano <a>www.parking.com</a></p>
          </li> -->
        </ul>
      </div>
    </div>
    <airbnb-modal v-if="showAirbnb"
                  :accommodation="accommodation"
                  @closeAirbnb="showAirbnb = false" />
    <stay-modal v-if="showStay"
                :accommodation="accommodation"
                @closeAirbnb="showStay = false" />
  </div>
</template>

<script>
import ArtistVenueCard from '@/components/artist-venue-card/ArtistVenueCard.vue'
import GoogleMapsModal from '@/components/google-maps-modal/GoogleMapsModal.vue'
import AirbnbModal from '@/components/airbnb/AirbnbModal.vue'
import StayModal from '@/components/stay/StayModal.vue'

export default {
  components: {
    ArtistVenueCard,
    GoogleMapsModal,
    AirbnbModal,
    StayModal
  },
  props: {
    transport: {
      type: Object,
      default: () => {}
    },
    accommodation: {
      type: Object,
      default: () => {}
    },
    venue: {
      type: Object,
      default: () => {}
    },
    title: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showAirbnb: false,
      showStay: false
    }
  },
  methods: {
    openAirbnb() {
      this.showAirbnb = true
    },
    openStay() {
      this.showStay = true
    }
  }
}
</script>

<style lang="scss">
@import './localization.sass';
</style>
